declare namespace $ {

	export class $mol_icon_chevron_double_right extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=right.view.tree.d.ts.map